import { render } from "./TestDetails.vue?vue&type=template&id=e0b287c2"
import script from "./TestDetails.vue?vue&type=script&lang=js"
export * from "./TestDetails.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/share/application/sanar-provider-webapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__